<template>
  <datepicker
    :disabled="disabled"
    :language="getLocale()"
    :format="format"
    :value="getDate(value)"
    :bootstrap-styling="true"
    input-class="form-control-overide"
    @input="$emit('input', $event)">
    <!-- NOT WORKING
    <div
      v-if="prepend"
      slot="beforeCalendarHeader"
      class="input-group-prepend align-self-stretch">
      <span class="input-group-text">{{ prepend }}</span>
    </div> -->
    <div
      v-if="required"
      slot="afterDateInput"
      class="input-group-append">
      <span
        id="inputGroupAppend"
        class="input-group-text">
        <i class="date-input-i fas fa-star-of-life"/>
      </span>
    </div>
  </datepicker>
</template>

<script>
import moment from 'moment';
import { en, fr } from 'vuejs-datepicker/dist/locale';
import ActionButton from '@/components/Actions/ActionButton';
import Datepicker from 'vuejs-datepicker';
import FormLabel from '@/components/Forms/FormLabel';

export default {
  name: 'DatePicker',
  components: {
    ActionButton,
    Datepicker,
    FormLabel,
  },
  props: {
    value: {
      type: [Date],
      default() {
        return moment().toDate();
      },
    },
    format: {
      type: String,
      default: 'dd MMMM yyyy',
    },
    prepend: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      en,
      fr,
    };
  },
  methods: {
    getLocale() {
      if (this.$i18n.locale === 'fr') {
        return this.fr;
      }
      return this.en;
    },
    getDate(value) {
      return moment(value).toDate();
    },
  },
};
</script>

<style lang="scss">
.form-control-overide {
  display: flex;
  height: auto !important;
}
.date-input-i {
  font-size: 10px;
}
</style>
